exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect__option:hover .text-muted[data-v-d6b0a28a]{color:var(--darken-primary-bg-contrast-text-color)!important}", ""]);

// exports
